import React, { useEffect, useRef } from 'react'
import Seo from './Seo'
import Contact from './conatct'
import Footer from './footer'
import { Container, Row, Col,  } from 'reactstrap'
import ObserverIMG from '../assets/images/Observer-Illustration.jpg'
import { ScrollEffect } from 'react-easy-scroll-effect'
import DownloadBrochure from './downloadBrochure'
import PHImg from '../assets/images/Hover Thumnail/Brochure-Banner.png'
import Velocis from '../assets/images/Thumnails/Velocis-Brochure.png'
import Agilus from '../assets/images/Thumnails/Agilus-Brochure.png'
import Bullseye from '../assets/images/Thumnails/BullsEye-Brochure.png'
import NetworkCompliance from '../assets/images/Compliance.png'
import DatasheetIMG from '../assets/images/datasheet.jpg'
import DatasheetIMGTheObserver from '../assets/images/Observer-Thumbnail.jpg'
import { Link } from 'react-router-dom'
import { use } from 'react'
export default function Resources() {

     const downlaodBroRef = useRef();
     const downloadBroClick = (val) =>{
        downlaodBroRef.current.openModal()
        downlaodBroRef.current.cnameFun(val)
    }

    useEffect(() => {
        document.title = 'Brochures & Data Sheets | Agilus Technologies'
      }, [])
  return (
    <div>
      <Seo
        title="Resources & Brochures"
        description="Explore Agilus resources including brochures, datasheets and detailed product insights."
        path="/brochure"
      />
      {/* hero section */}

      <section className='custom-margin-for-header'>
            <img src={PHImg} className='img-fluid' />
        </section>

        <section className='ce-hero-section py-5 text-center'>
            <Container >
                <Row>
                <Col sm={12} className=''>
                    <h1 className='fw-normal font-50 archivo-medium'>Brochures & Data Sheets</h1>
                    <p>Dive into our resource library to access a comprehensive collection of brochures, datasheets, and in-depth insights about our offerings. Whether you're looking for detailed product specifications or an overview of our solutions, you'll find everything you need to make informed decisions. Explore now and discover how we can help address your unique challenges.</p>
                </Col>
                </Row>
            </Container>

        </section>

         {/* blog */}
         <section className='blog px-3 pb-5 my-4 archivo-normal'>
            <div className='p-5 custom-rounded bg-gray-light'>
            <ScrollEffect id='8'>
                <Container>
                <Row>
                    {/* <Col sm={12} className='text-center mb-4'>
                        <h1 className='fw-semibold'>Latest Article</h1>
                    </Col> */}
                    
                    <Col col={12} md={6} xl={4} xxl={4} lg={4}>
                        <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({title:'Simply Simplifying IT Infrastructure Management', cname:'Agilus', fileType : 'Brochure'})}>
                            <img src={Agilus} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div>Simply Simplifying IT Infrastructure Management</div>
                            {/* <hr className='my-0'/>
                            
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col col={12} md={6} xl={4} xxl={4} lg={4}>
                        <div className='blog-item blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title : 'Simply Simplifying IT Infrastructure Management',  cname : 'BullsEye', fileType : 'Brochure'})}>
                            <img src={Bullseye} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal'><DownloadBrochure 
                            ref={downlaodBroRef}
                             />  </h5>
                              <div>A Conversational multi-domain Root Cause Analysis engine</div>
                            {/* <hr className='my-0'/>
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col col={12} md={6} xl={4} xxl={4} lg={4} >
                        <div className='blog-item  blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title:'Simplifies Network Compliance Operations' , cname :'Network Compliance Platform', fileType : 'Brochure' })}>
                            <img src={NetworkCompliance} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div> Ensure Compliance with Automated Audits and Best Practices enforcement </div>
                            {/* <hr className='my-0'/>
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col col={12} md={6} xl={4} xxl={4} lg={4} className='mt-4'>
                        <div className='blog-item  blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title:'Helping Organisations Get Future Ready' , cname :'Velocis Corporate Profile' , fileType : 'Brochure'})}>
                            <img src={Velocis} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-green'>Download Brochure</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div> Helping Organisations Get Future Ready </div>
                            {/* <hr className='my-0'/>
                            <div className='blog-datetime'>October 5, 2021 | 4min read</div> */}
                        </div>
                    </Col>
                    <Col col={12} md={6} xl={4} xxl={4} lg={4} className='mt-4'>
                        <div className='blog-item  blog-item-height custom-rounded cursor-pointer' onClick={()=> downloadBroClick({ title:'Network Compliance Platform | Data Sheet' , cname :'Network Compliance Platform | Data Sheet', fileType : 'Datasheet' })}>
                            <img src={DatasheetIMG} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-pink'>Download Data Sheet</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div> Network Compliance Platform | Data Sheet </div>
                        </div>
                    </Col>
                    <Col col={12} md={6} xl={4} xxl={4} lg={4} className='mt-4'>
                        <div className='blog-item  blog-item-height custom-rounded cursor-pointer' style={{minHeight: 415}} onClick={()=> downloadBroClick({ title:'The Observer | Data Sheet' , cname :'The Observer | Data Sheet', fileType : 'Datasheet' })}>
                            <img src={DatasheetIMGTheObserver} className='img-fluid custom-rounded'/>
                            <span className='blog-tag blog-tag-bg-pink'>Download Data Sheet</span>
                            <h5 className='fw-normal cursor-pointer'><DownloadBrochure ref={downlaodBroRef} /> </h5>
                            <div> The Observer | Data Sheet </div>
                        </div>
                    </Col>
                    
                    
                </Row>
                </Container>
                </ScrollEffect>
            </div>
        </section>
    
    {/* contact */}
    <Contact />

    {/* footer */}
    <Footer />
    </div>
  )
}
